import { render, staticRenderFns } from "./Turmacrud.vue?vue&type=template&id=75a230f0&"
import script from "./Turmacrud.vue?vue&type=script&lang=js&"
export * from "./Turmacrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports